import React from 'react';
import {
    Box,
    Typography,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Chip
} from '@mui/material';
import { styled } from '@mui/material/styles';

const Card = styled(Box)({
    backgroundColor: '#202020',
    borderRadius: '12px',
    padding: '1.5rem',
});

const Cell = styled(TableCell)({
    color: '#fff',
    fontSize: '0.85rem',
    whiteSpace: 'nowrap',
});

const CourierTransactions = ({ transactions = [] }) => {
    return (
        <Card>
            <Typography variant="h6" gutterBottom>
                Transactions
            </Typography>

            {transactions.length === 0 ? (
                <Typography variant="body2" color="#9e9e9e">
                    No transactions recorded.
                </Typography>
            ) : (
                <Table>
                    <TableHead>
                        <TableRow>
                            <Cell>Date</Cell>
                            <Cell>Amount</Cell>
                            <Cell>Status</Cell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {transactions.map((t, idx) => (
                            <TableRow key={idx}>
                                <Cell>
                                    {new Date(t.date).toLocaleDateString()}
                                </Cell>
                                <Cell>${t.amount}</Cell>
                                <Cell>
                                    <Chip
                                        size="small"
                                        label={t.status}
                                        sx={{
                                            backgroundColor:
                                                t.status === 'Paid'
                                                    ? '#12c099'
                                                    : '#ffa726',
                                            color: '#000',
                                        }}
                                    />
                                </Cell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            )}
        </Card>
    );
};

export default CourierTransactions;
